import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsSoftwareDetailsRoute: InvariantJiraRoute = {
	name: 'project-settings-software-details',
	path: '/jira/software/projects/:projectKey/settings/details',
	exact: true,
};
